<template>
    <el-col :span="12" style="text-align: left; padding-top: 20px">
        <h3 style="font-weight: bold; text-align: left; padding-left: 80px"> Introduction </h3>
    </el-col>
    <el-col :span="16" style="text-align: left; padding-top: 10px; padding-left: 80px; font-size: 15px;">
      <br/>
      <p style="font-size: 15px;">Thank you for your decision to purchase the Dragon Promo Kit</p>
      <p style="font-size: 15px;">Future Electronics and Panasonic are sponsors of the Dragon Promo Kit, a non-certified engineering kit intended to assist developers in evaluating IOSEA’s RTLS System based on Angle of Arrival (AoA) using Panasonic’s PAN1781 Tag Reference design or Jaguar Tag.</p>
    </el-col>
</template>